const whitelabelConfig = {
  'default': {
    'brand': 'default',
    'scssVariables': './src/styles/whitelabel-variables/default',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 0, // 100%
        'discountAppliesToPackages': ['premium', 'komfort', 'basis'],
        'discountAppliesToPriceTypes': ['monatlicher', 'einmaliges']
      }
    ]
  },
  'pflegegrad-beantragen': {
    'brand': 'pflegegrad-beantragen',
    'scssVariables': './src/styles/whitelabel-variables/pflegegrad-beantragen',
    'title': 'Die Notruflösungen der Johanniter',
  },
  'pflegemarkt': {
    'brand': 'pflegemarkt',
    'scssVariables': './src/styles/whitelabel-variables/pflegemarkt',
    'title': 'Die Notruflösungen von Pflegemarkt',
  },
  'harz-energie': {
    'brand': 'harz-energie',
    'scssVariables': './src/styles/whitelabel-variables/harz-energie',
    'title': 'Die Notruflösungen von Harz Energie',
  },
  'mitpflegeleben': {
    'brand': 'mitpflegeleben',
    'scssVariables': './src/styles/whitelabel-variables/mitpflegeleben',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
  },
  'stadtwerkeneuss': {
    'brand': 'stadtwerkeneuss',
    'scssVariables': './src/styles/whitelabel-variables/stadtwerkeneuss',
    'title': 'Die Notruflösungen der Johanniter',
  },
  'stadtwerkewertheim': {
    'brand': 'stadtwerkewertheim',
    'scssVariables': './src/styles/whitelabel-variables/stadtwerkewertheim',
    'title': 'Die Notruflösungen der Johanniter',
  },
  'swg': {
    'brand': 'swg',
    'scssVariables': './src/styles/whitelabel-variables/swg',
    'title': 'Die Notruflösungen der Johanniter',
  },
  'thuegaenergie': {
    'brand': 'thuegaenergie',
    'scssVariables': './src/styles/whitelabel-variables/thuegaenergie',
    'title': 'Die Notruflösungen der Johanniter',
  },
  'seniorenportal': {
    'brand': 'faz',
    'scssVariables': './src/styles/whitelabel-variables/seniorenportal',
    'title': 'Die Notruflösungen der Johanniter',
  },
  'aue-bad-schlema': {
    'brand': 'aue-bad-schlema',
    'scssVariables': './src/styles/whitelabel-variables/aue-bad-schlema',
    'title': 'Die Notruflösungen der Johanniter',
  },
  'bad-bramstedt': {
    'brand': 'bad-bramstedt',
    'scssVariables': './src/styles/whitelabel-variables/bad-bramstedt',
    'title': 'Die Notruflösungen der Johanniter',
  },
  'zwickauer-energieversorgung': {
    'brand': 'zwickauer-energieversorgung',
    'scssVariables': './src/styles/whitelabel-variables/zwickauer-energieversorgung',
    'title': 'Die Notruflösungen der Johanniter',
  },
  'hausnotruf-testen': {
    'brand': 'hausnotruf-testen',
    'scssVariables': './src/styles/whitelabel-variables/hausnotruf-testen',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 0, // 100%
        'discountAppliesToPackages': ['premium', 'komfort', 'basis'],
        'discountAppliesToPriceTypes': ['monatlicher', 'einmaliges']
      }
    ]
  },
  'liftstar': {
    'brand': 'liftstar',
    'scssVariables': './src/styles/whitelabel-variables/liftstar',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 0, // 100%
        'discountAppliesToPackages': ['premium', 'komfort', 'basis'],
        'discountAppliesToPriceTypes': ['monatlicher', 'einmaliges']
      }
    ]
  },
  'careship': {
    'brand': 'careship',
    'scssVariables': './src/styles/whitelabel-variables/careship',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
  },
  'hanova': { // This white label has custom calculation inside the pinia store
    'brand': 'hanova',
    'scssVariables': './src/styles/whitelabel-variables/hanova',
    'title': 'Die Notruflösungen von Harz Energie',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 0.75, // 25%
        'discountAppliesToPackages': ['premium', 'komfort'],
        'discountAppliesToPriceTypes': ['monatlicher']
      },
    ]
  },
  'meravis': { // This white label has custom calculation inside the pinia store
    'brand': 'meravis',
    'scssVariables': './src/styles/whitelabel-variables/meravis',
    'title': 'Die Notruflösungen von Harz Energie',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 1, // 0%
        'discountAppliesToPackages': ['premium', 'komfort'],
        'discountAppliesToPriceTypes': ['monatlicher']
      },
      {
        'discountType': 'percentage',
        'discountAmount': 0, // 100%
        'discountAppliesToPackages': ['premium', 'komfort'],
        'discountAppliesToPriceTypes': ['einmaliges']
      }
    ]
  },
  'wohnbau-kleefeld-buchholz': { // This white label has custom calculation inside the pinia store
    'brand': 'wohnbau-kleefeld-buchholz',
    'scssVariables': './src/styles/whitelabel-variables/wohnbau-kleefeld-buchholz',
    'title': 'Die Notruflösungen von Harz Energie',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 1, // 0%
        'discountAppliesToPackages': ['premium', 'komfort'],
        'discountAppliesToPriceTypes': ['monatlicher']
      },
      {
        'discountType': 'percentage',
        'discountAmount': 0, // 100%
        'discountAppliesToPackages': ['premium', 'komfort'],
        'discountAppliesToPriceTypes': ['einmaliges']
      }
    ]
  },
  'swd': {
    'brand': 'swd',
    'scssVariables': './src/styles/whitelabel-variables/swd',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
  },
  'burda': {
    'brand': 'burda',
    'scssVariables': './src/styles/whitelabel-variables/burda',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 0, // 100%
        'discountAppliesToPackages': ['premium', 'komfort', 'basis'],
        'discountAppliesToPriceTypes': ['monatlicher', 'einmaliges']
      }
    ]
  },
  'pflegedienst-angela': {
    'brand': 'pflegedienst-angela',
    'scssVariables': './src/styles/whitelabel-variables/pflegedienst-angela',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
  },
  'stadtwerke-heide': {
    'brand': 'stadtwerke-heide',
    'scssVariables': './src/styles/whitelabel-variables/stadtwerke-heide',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
  },
  'stadtwerke-greven': {
    'brand': 'stadtwerke-greven',
    'scssVariables': './src/styles/whitelabel-variables/stadtwerke-greven',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
  },
  'zbvv': {
    'brand': 'zbvv',
    'scssVariables': './src/styles/whitelabel-variables/zbvv',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 0, // 100%
        'discountAppliesToPackages': ['premium', 'komfort', 'basis'],
        'discountAppliesToPriceTypes': ['monatlicher', 'einmaliges']
      }
    ]
  },
  'spiribo': {
    'brand': 'spiribo',
    'scssVariables': './src/styles/whitelabel-variables/spiribo',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 0, // 100%
        'discountAppliesToPackages': ['premium', 'komfort', 'basis'],
        'discountAppliesToPriceTypes': ['monatlicher', 'einmaliges']
      }
    ]
  },
  'sanimed': {
    'brand': 'sanimed',
    'scssVariables': './src/styles/whitelabel-variables/sanimed',
    'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
  },
  'seniorenfocus': {
    'brand': 'seniorenfocus',
    'scssVariables': './src/styles/whitelabel-variables/seniorenfocus'
  },
  'seniorenfocus-nord': {
    'brand': 'seniorenfocus-nord',
    'scssVariables': './src/styles/whitelabel-variables/seniorenfocus-nord'
  },
  'seniorenfocus-bawue': {
    'brand': 'seniorenfocus-bawue',
    'scssVariables': './src/styles/whitelabel-variables/seniorenfocus-bawue'
  },
  'seniorenfocus-ndsb': {
    'brand': 'seniorenfocus-ndsb',
    'scssVariables': './src/styles/whitelabel-variables/seniorenfocus-ndsb'
  },
  'corporatebenefits': {
    'brand': 'corporatebenefits',
    'scssVariables': './src/styles/whitelabel-variables/corporatebenefits',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 0.90, // 10%
        'discountAppliesToPackages': ['premium', 'komfort'],
        'discountAppliesToPriceTypes': ['monatlicher']
      }
    ]
  },
  'landingpage-bawue-messe': {
    'brand': 'landingpage-bawue-messe',
    'scssVariables': './src/styles/whitelabel-variables/landingpage-bawue-messe',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 0, // 100%
        'discountAppliesToPackages': ['premium', 'komfort', 'basis'],
        'discountAppliesToPriceTypes': ['einmaliges']
      },
      {
        'discountType': 'fixed',
        'discountAmount': 49.00, // fixed price
        'discountAppliesToPackages': ['komfort'],
        'discountAppliesToPriceTypes': ['monatlicher']
      }
    ]
  },
  'enercity': {
    'brand': 'enercity',
    'scssVariables': './src/styles/whitelabel-variables/enercity',
    'title': 'Die Notruflösungen von Harz Energie',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 0.90, // 10%
        'discountAppliesToPackages': ['premium', 'komfort'],
        'discountAppliesToPriceTypes': ['monatlicher']
      },
    ]
  },
  'wemag': {
    'brand': 'wemag',
    'scssVariables': './src/styles/whitelabel-variables/wemag',
    'discountSettings': [
      {
        'discountType': 'percentage',
        'discountAmount': 0, // 100%
        'discountAppliesToPackages': ['premium', 'komfort', 'basis'],
        'discountAppliesToPriceTypes': ['einmaliges', 'monatlicher']
      },
    ]
  },
  'agfh': {
    'brand': 'agfh',
    'scssVariables': './src/styles/whitelabel-variables/agfh'
  }
}

module.exports = whitelabelConfig;
